import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';

type Props = {
  dot: Matches.PositionedDot;
  left: string;
  top: string;
};

const TOOLTIP_LEAVE_TOUCH_DELAY_MS = 6000;

export const AssertionDot: React.FC<Props> = ({ dot, left, top }) => {
  const [open, setOpen] = React.useState(false);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      setOpen(prev => !prev);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  };

  return (
    <Tooltip
      arrow
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      enterTouchDelay={0}
      leaveTouchDelay={TOOLTIP_LEAVE_TOUCH_DELAY_MS}
      title={
        <Box sx={{ py: 0.5 }}>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            {dot.content}
          </Typography>
          <Typography variant="caption">
            You answered: <strong>{dot.answer}</strong>
          </Typography>
        </Box>
      }
    >
      <Box
        role="button"
        tabIndex={0}
        aria-label={`${dot.content} — You answered: ${dot.answer}`}
        onKeyDown={handleKeyDown}
        sx={{
          position: 'absolute',
          left,
          top,
          transform: 'translate(-50%, -50%)',
          width: 26,
          height: 26,
          borderRadius: '50%',
          bgcolor: dot.color,
          border: '2px solid rgba(255, 255, 255, 0.9)',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 12,
          fontWeight: 700,
          lineHeight: 1,
          cursor: 'pointer',
          boxShadow: 2,
          transition: 'transform 0.12s ease',
          '&:hover': {
            transform: 'translate(-50%, -50%) scale(1.2)',
            zIndex: 2,
          },
          '&:focus-visible': {
            transform: 'translate(-50%, -50%) scale(1.2)',
            zIndex: 2,
            outline: '2px solid #fff',
            outlineOffset: 2,
          },
        }}
      >
        {dot.number}
      </Box>
    </Tooltip>
  );
};
